import React, { memo } from "react";
import moment from "moment-timezone";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { setDangerouslyInnerHtml } from "../../../helpers/set-inner-html";
import { moduleSettings } from "../../../stores/module-settings.store";
import { getLanguageSwitcherService } from "../../../services/language-switcher.service";
import bookingService from "../../../services/booking-service";
import i18n from "../../../../src/i18n";
import { pendingBookingStore } from "../../../stores/pending-booking.store";
interface SummaryProps {
  civility?: number;
  firstname: string;
  lastname: string;
  booked_persons_number: number;
  children_number: number;
  time: string;
}

const SummaryWrapper = styled.div`
  max-width: 500px;
  padding: 24px 32px;
  margin: 24px auto 32px;
  text-align: center;
  background-color: ${(props) => props.theme.backgroundColor};
  border-radius: 4px;
`;

const Summary = (props: SummaryProps) => {
  const { t } = useTranslation();
  const contact = bookingService.displayName(
    props.firstname,
    props.lastname,
    props.civility
  );
  const count = props.booked_persons_number;
  const childrenNumber = props.children_number;
  const timezone = moduleSettings.restaurantTimezone;
  moment.locale(getLanguageSwitcherService().localeForMoment());
  const date = moment(props.time).tz(timezone).format("D MMMM");
  const skip_prepayment_for_contact =
    pendingBookingStore.skip_prepayment_for_contact;

  const hour =
    moment(props.time).tz(timezone).format("HH") +
    "h" +
    moment(props.time).format("mm");
  const restaurant = moduleSettings.getRestaurantName();

  const setMessage = (): string => {
    switch (childrenNumber) {
      case 0:
        return count > 1
          ? "instabook.bookings.summary.other"
          : "instabook.bookings.summary.one";
      default:
        return "instabook.bookings.summary_with_children";
    }
  };

  const setParams = () => {
    switch (childrenNumber) {
      case 0:
        return {
          contact,
          count,
          date,
          hour,
          restaurant,
        };
      default:
        const children =
          childrenNumber > 1
            ? childrenNumber + " " + t("instabook.common.children")
            : 1 + " " + t("instabook.common.child");
        return {
          contact,
          count,
          children,
          date,
          hour,
          restaurant,
        };
    }
  };

  return (
    <SummaryWrapper data-test="booking-summary">
      <span
        dangerouslySetInnerHTML={setDangerouslyInnerHtml(
          t,
          setMessage(),
          setParams()
        )}
      />
      {skip_prepayment_for_contact && (
        <span
          dangerouslySetInnerHTML={{
            __html: t("instabook.bookings.summary_with_prepayment_skipped"),
          }}
        />
      )}
    </SummaryWrapper>
  );
};
export const BookingSummary = memo(Summary);
